<template>
  <course-container title="课程评论管理">
    <div class="wrapper">
      <div class="course-detail">
        <template v-if="courseDetail">
          <div
            class="cover"
            :style="{
              backgroundImage: `url(${courseDetail.detail.coverImagUrl})`
            }"
          ></div>
          <div>
            <div class="course-title">{{ courseDetail.detail.title }}</div>
            <div class="course-author">
              <span>{{ courseDetail.authorInfo.name }}</span> |
              <span>{{ courseDetail.detail.tag }}</span>
              <span class="course-count"
                >共{{ courseDetail.detail.courseCount }}节</span
              >
            </div>
            <div class="course-description">
              {{ courseDetail.detail.description }}
            </div>
          </div>
        </template>
      </div>
      <div>
        <CommentList
          :disabled="false"
          :comments-info="courseDetail.commentsInfo"
        ></CommentList>
      </div>
    </div>
  </course-container>
</template>

<script>
import CourseContainer from '@/components/AuthorCourse/CourseContainer'
import CommentList from '@/components/CommentList'
import { getCourseDetail } from '@/api/course'
export default {
  name: 'AuthorCourseComment',
  components: { CourseContainer, CommentList },
  data() {
    return {
      courseDetail: {
        authorInfo: {},
        commentsInfo: {},
        courses: {},
        detail: {}
      }
    }
  },
  computed: {
    courseSetId() {
      return this.$route.params.id
    }
  },
  created() {
    this.getCourseSections()
  },
  methods: {
    async getCourseSections() {
      const courseDetail = await getCourseDetail(this.courseSetId)
      if (courseDetail) {
        this.courseDetail = courseDetail
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 30px 0;
}

.input-title-label {
  color: #046bcc;
  cursor: pointer;
}

.input-title {
  display: inline-block;
  width: 100%;
  border: none;
  text-align: center;
  overflow: auto;
  box-sizing: border-box;
  resize: none;
  line-height: 20px;
  padding: 5px;
  height: 100%;

  &:focus {
    outline: none;
  }
}

.course-detail {
  display: flex;
  min-height: 190px;
  border-bottom: 1px solid #ebebeb;
  margin-bottom: 20px;

  .cover {
    width: 160px;
    height: 120px;
    margin-right: 20px;
    background: no-repeat center;
    background-size: cover;
  }

  .course-title {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 1px;
    color: #262626;
  }

  .course-author {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 1px;
    color: #858585;
  }

  .course-count {
    display: inline-block;
    width: 60px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    background-color: rgba(#046bcc, 0.1);
    border-radius: 12px;
    margin-left: 20px;
    font-size: 14px;
    color: #046bcc;
  }

  .course-description {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 1px;
    color: #858585;
  }
}

.video-list {
  padding: 30px 0;
}

.video-row,
.video-row-title {
  width: 766px;
  display: flex;
  text-align: center;

  .video-col {
    width: 0;
    flex: auto;
  }

  .video-col1 {
    flex: 0 0 60px;
  }

  .video-col2 {
    flex: 0 0 120px;
  }

  .video-col3 {
    flex: 0 0 50px;
  }
}

.video-row {
  position: relative;
  font-size: 12px;
  color: #262626;
  height: 120px;
  border: 1px solid #ebebeb;
  margin: 24px 0 80px;
  line-height: 18px;

  .video-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:nth-child(n + 2) {
      border-left: 1px solid #ebebeb;
    }

    .video-col_item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 0;
      flex: auto;
      .video-col_item-p {
        cursor: pointer;
        &:hover {
          color: #046bcc;
        }
      }
    }

    .video-col_item:first-child {
      border-bottom: 1px solid #ebebeb;
    }

    .video-col_item > p {
      position: relative;
      line-height: 1.5em;
      /* 高度为需要显示的行数*行高，比如这里我们显示两行，则为3 */
      height: 3em;
      overflow: hidden;
    }
    .video-col_item > p::after {
      content: '...';
      position: absolute;
      bottom: 0;
      right: 0;
      padding: 0 5px;
      background-color: #fff;
    }
  }

  .video-col1 {
    background-color: #fafafa;
  }

  .video-col7 {
    .video-col_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
}

.parting-line {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -60px;
  height: 1px;
  background-color: #ebebeb;
}

.button-apply {
  position: absolute;
  right: 0;
  bottom: -42px;
  width: 80px;
  height: 26px;
  line-height: 24px;
  padding: 0;
}

.upload-progress {
  width: 60px;
  padding: 8px 0;
}

.video-row-title {
  font-size: 14px;
  line-height: 40px;
  background-color: #f0f0f0;
  color: #858585;
}

.button-add {
  width: 100px;
  height: 30px;
  line-height: 28px;
  padding: 0;
}
.upload-require:after {
  content: '*';
  color: red;
}
</style>

<style>
.el-dialog__header {
  padding-top: 5px;
  padding-bottom: 15px;
  border: 1px solid #ebebeb;
}
.el-dialog__body {
  padding: 15px 15px 20px;
}
</style>
